/**
 * Security Utilities for Strider Application
 * Implements code protection and anti-copy measures
 */

// Disable right-click context menu
export const disableRightClick = () => {
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });
};

// Disable keyboard shortcuts for developer tools and source viewing
export const disableDevToolsShortcuts = () => {
  document.addEventListener('keydown', (e) => {
    // Disable F12
    if (e.key === 'F12' || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+Shift+I (Developer Tools)
    if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+Shift+C (Element Inspector)
    if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+U (View Source)
    if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+S (Save Page)
    if (e.ctrlKey && (e.key === 'S' || e.key === 's') && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
  });
};

// Disable text selection on specific elements
export const disableTextSelection = () => {
  const style = document.createElement('style');
  style.textContent = `
    .no-select {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    
    /* Allow selection on input fields and textareas */
    input, textarea, [contenteditable="true"] {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `;
  document.head.appendChild(style);
};

// Detect if dev tools are open
export const detectDevTools = (callback) => {
  const threshold = 160; // Dev tools typically add width/height
  let devtoolsOpen = false;
  
  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      if (!devtoolsOpen) {
        devtoolsOpen = true;
        if (callback) callback(true);
      }
    } else {
      if (devtoolsOpen) {
        devtoolsOpen = false;
        if (callback) callback(false);
      }
    }
  };
  
  // Check periodically
  setInterval(checkDevTools, 500);
  window.addEventListener('resize', checkDevTools);
};

// Console clearing and warning
export const protectConsole = () => {
  // Add warning message to console
  const warningStyle = 'font-size: 24px; color: #e74c3c; font-weight: bold;';
  const infoStyle = 'font-size: 14px; color: #333;';
  
  console.log('%cSTOP!', warningStyle);
  console.log('%cThis is a browser feature intended for developers.', infoStyle);
  console.log('%cIf someone told you to copy-paste something here to enable a Strider feature or "hack" your account, it is a scam.', infoStyle);
  console.log('%cStay safe! Do not enter any code here.', infoStyle);
};

// Disable drag and drop on images
export const disableImageDrag = () => {
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });
};

// Disable print screen (partial - cannot fully prevent)
export const disablePrintScreen = () => {
  document.addEventListener('keyup', (e) => {
    if (e.key === 'PrintScreen') {
      // Clear clipboard (doesn't work in all browsers)
      navigator.clipboard.writeText('');
    }
  });
};

// Add watermark overlay (hidden until printed/screenshotted)
export const addWatermark = () => {
  const style = document.createElement('style');
  style.textContent = `
    @media print {
      body::after {
        content: 'Strider - Confidential';
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
        font-size: 72px;
        color: rgba(45, 178, 174, 0.15);
        z-index: 99999;
        pointer-events: none;
        white-space: nowrap;
      }
    }
  `;
  document.head.appendChild(style);
};

// Initialize all security measures
export const initializeSecurity = (options = {}) => {
  const {
    disableInspect = true,
    disableCopy = false, // Keep copy enabled for user convenience
    showConsoleWarning = true,
    enableWatermark = true,
    devToolsCallback = null
  } = options;
  
  // Only apply in production
  const isProduction = process.env.NODE_ENV === 'production';
  
  if (isProduction || options.forceEnable) {
    if (disableInspect) {
      disableRightClick();
      disableDevToolsShortcuts();
    }
    
    if (disableCopy) {
      disableTextSelection();
    }
    
    disableImageDrag();
  }
  
  if (showConsoleWarning) {
    protectConsole();
  }
  
  if (enableWatermark) {
    addWatermark();
  }
  
  if (devToolsCallback) {
    detectDevTools(devToolsCallback);
  }
};

export default {
  initializeSecurity,
  disableRightClick,
  disableDevToolsShortcuts,
  disableTextSelection,
  detectDevTools,
  protectConsole,
  disableImageDrag,
  disablePrintScreen,
  addWatermark
};
